<template>
  <w-icon-wrapper 
    :height='24'
    :width='21.49'
    icon-name='work-download-icon'
    view-box='0 0 21.49 24'
  >
    <!-- <defs>
      <style>
        .cls-1 {
          fill: #4173ff;
        }
      </style>
    </defs> -->
    <g>
      <path 
        d="M14,0H0v24h2.87c.55,0,1-.45,1-1h0c0-.55-.45-1-1-1h-.87V2h10v6h6v8.63c0,.55.45,1,1,1h0c.55,0,1-.45,1-1V6L14,0ZM14,6v-3.17l3.17,3.17h-3.17Z" 
        fill='currentColor'
      />
      <path 
        d="M9.94,16.34l.53-.54s.04-.04.06-.06l2.24-2.28c.3-.3.3-.79,0-1.1-.29-.3-.77-.31-1.07,0l-.98,1v-4.45c0-.43-.34-.77-.76-.77s-.76.35-.76.77v4.44l-.97-1.02c-.29-.31-.77-.31-1.07-.02-.15.15-.23.35-.23.56s.07.39.21.54l2.78,2.93Z" 
        fill='currentColor'
      />
    </g>
    <g>
      <path 
        d="M5.47,22.58c.21,0,.38.06.49.18s.17.27.17.45-.06.33-.17.44-.28.18-.49.18-.36-.06-.48-.17-.18-.26-.18-.45.06-.33.17-.45.28-.18.49-.18Z"
        fill='currentColor'
      />
      <path 
        d="M9.53,22.97c.29,0,.52-.08.71-.25s.29-.37.3-.62h1.08c-.01.32-.11.61-.3.89s-.44.49-.75.65-.66.24-1.02.24c-.71,0-1.27-.23-1.69-.69s-.62-1.1-.62-1.91v-.12c0-.77.21-1.39.62-1.86s.98-.7,1.69-.7c.6,0,1.1.18,1.48.53s.58.82.6,1.39h-1.08c-.01-.29-.11-.53-.3-.72s-.42-.28-.71-.28c-.37,0-.65.13-.86.4s-.3.67-.31,1.22v.18c0,.55.1.96.3,1.23s.49.41.86.41Z" 
        fill='currentColor'
      />
      <path 
        d="M15.33,22.4c0-.2-.08-.36-.25-.47s-.45-.2-.83-.28-.71-.18-.97-.31c-.57-.28-.86-.67-.86-1.2,0-.44.18-.8.55-1.1s.84-.44,1.41-.44c.61,0,1.1.15,1.47.45s.56.69.56,1.17h-1.14c0-.22-.08-.4-.24-.55s-.38-.22-.65-.22c-.25,0-.45.06-.61.17s-.24.27-.24.47c0,.18.07.31.22.41s.44.19.89.29.8.22,1.05.35.44.3.57.49.19.42.19.7c0,.46-.19.83-.57,1.11s-.88.43-1.49.43c-.42,0-.79-.08-1.11-.23s-.58-.36-.76-.62-.27-.55-.27-.85h1.11c.02.27.12.48.31.62s.44.22.75.22.53-.06.69-.17.23-.26.23-.45Z" 
        fill='currentColor'
      />
      <path 
        d="M19.24,22.34l1.08-3.64h1.18l-1.76,5.08h-.99l-1.78-5.08h1.18l1.09,3.64Z"
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDownloadCsv' };
</script>